<div class="complete-umbrueckung-dialog">

  <div class="dialog-layout">
    <h2 class="dialog-h2">
      <sc-dictionary-label dictionaryKey="tmc-yard.ui.control.sac-client.complete-umbrueckung-dialog.title"></sc-dictionary-label>
    </h2>


    <div class="top-info">
      <app-transport-info-panel [carrier]="details.carrier" [identifier]="details.identifier" [driver]="details.name"
        [scope]="details.transportScope"></app-transport-info-panel>
    </div>

    <div class="dialog-content">
      <div [innerHTML]="'the trailer of the selected transport of currently beeing swapped, you can cancel or complete this process.' | translate: ['tmc-yard.ui.control.sac-client.complete-umbrueckung-dialog.info-text', translationService.language, translationService.revision] |
        trustHtml">
      </div>

      <div class="messages">
        <app-service-response [responseMessages]="responseMessages"></app-service-response>
      </div>

    </div>



    <sc-actionbar>
      <sc-content-spacer grow></sc-content-spacer>
      <button mat-stroked-button class="cancel-button" (click)="closeDialog()">
        <sc-dictionary-label dictionaryKey="tmc-yard.common.action.cancel"></sc-dictionary-label>
      </button>
      <sc-content-spacer></sc-content-spacer>
      <sc-button class="" (click)="cancel()"
        dictionaryKey="tmc-yard.ui.control.sac-client.complete-umbrueckung-dialog.action.cancel-swap">
        <sc-dictionary-label dictionaryKey="tmc-yard.ui.control.sac-client.complete-umbrueckung-dialog.action.cancel-swap"></sc-dictionary-label>
      </sc-button>
      <sc-content-spacer></sc-content-spacer>
      <sc-button class="confirm-button" primary (click)="complete()"
        dictionaryKey="tmc-yard.ui.control.sac-client.complete-umbrueckung-dialog.action.complete">
        <sc-dictionary-label dictionaryKey="tmc-yard.ui.control.sac-client.complete-umbrueckung-dialog.action.complete"></sc-dictionary-label>
      </sc-button>
    </sc-actionbar>
  </div>
</div>
